import ACLStore from "lib/aclStore";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "assessment-transfer",
  component: withAsyncRouteLoading(() => {
    const isV2 = ACLStore.can("IsEnabledImportGradebook");
    if (isV2) {
      return Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "../AssessmentTransferV2/components"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "../AssessmentTransferV2/modules/AssessmentTransferV2Module"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        injectReducer(store, { key, reducer });
        return component;
      });
    }

    return Promise.all([
      import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "./modules/AssessmentTransferModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const module = importedModule1;
      const reducer = module.default;
      const key = module.NAME;
      injectReducer(store, { key, reducer });
      return component;
    });
  }),
});
